// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1AhHQ","form":"styles_form__2P2qS"};